import React from 'react';
import { Truck, Phone, Clock } from 'lucide-react';

const BulkOrder = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-md p-8">
          <h1 className="text-3xl font-bold mb-6">Bulk Mangoes 2025</h1>
          <p className="text-lg text-gray-700 mb-4">For Reseller, Group Order, Gift Purpose</p>
          
          {/* Notice Banner */}
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mb-8">
            <p className="text-yellow-700 font-medium">
              Note: Bulk orders with pickup are currently available only in Andhra Pradesh and Telangana regions.
            </p>
          </div>

          {/* Delivery Highlight */}
          <div className="bg-gradient-to-r from-yellow-500 to-yellow-400 text-white p-6 rounded-lg mb-8 shadow-lg">
            <div className="flex items-start space-x-4">
              <Clock className="h-8 w-8 flex-shrink-0 mt-1" />
              <div>
                <h3 className="text-xl font-semibold mb-2">Quick Delivery Promise</h3>
                <p className="text-white/90 leading-relaxed">
                  We strive to deliver fresh mangoes to our customers. Once harvested, we ensure delivery within 24-48 hours directly to the customer.
                </p>
              </div>
            </div>
          </div>

          {/* Price and Order Details */}
          <div className="bg-yellow-50 p-6 rounded-lg mb-8">
            <p className="text-xl font-semibold mb-4">For bulk orders, the price will be the same for all varieties—₹200/kg is the fixed price.</p>
            <p className="text-lg font-medium">Minimum Order: 5 Number Wooden Box for bulk</p>
          </div>

          {/* Peti Quantity Details */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Inside Box Quantity Details:</h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-center">
                <span className="w-4 h-4 bg-yellow-500 rounded-full mr-3"></span>
                4 Dozens (210 to 260 gram each)
              </li>
              <li className="flex items-center">
                <span className="w-4 h-4 bg-yellow-500 rounded-full mr-3"></span>
                5 dozens (210 to 260 gram each)
              </li>
              <li className="flex items-center">
                <span className="w-4 h-4 bg-yellow-500 rounded-full mr-3"></span>
                6 Dozens (160-210 gram each)
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Pickup Locations</h2>
            <div className="space-y-6">
              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Anakapally</h3>
                <p className="text-gray-700">Kasimkota, Amalodbhavi restaurant</p>
                <p className="text-green-600">Pickup available on the same day.</p>
              </div>

              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Vijayawada</h3>
                <p className="text-gray-700">Ramvarapadu ring road</p>
                <p className="text-green-600">Pickup available after 1 or 2-Days after order </p>
              </div>

              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Gannavaram</h3>
                <p className="text-gray-700">Gannavaram airport</p>
                <p className="text-green-600">Pickup available after 1 or 2-Days after order</p>
              </div>
              
              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Hyderbad</h3>
                <p className="text-gray-700">Kondapur</p>
                <p className="text-gray-600">Pickup available after 1 or 2-Days after order</p>
              </div>

              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Guntur</h3>
                <p className="text-gray-700">Chilakaluripeta</p>
                <p className="text-gray-600">Pickup available after 1 or 2-Days after order</p>
              </div>

              <div className="border-l-4 border-yellow-500 pl-4">
                <h3 className="font-semibold mb-2">Nellore</h3>
                <p className="text-gray-700">Trunk Road</p>
                <p className="text-gray-600">Pickup available after 1- or 2-Days after order</p>
              </div>
            </div>
          </div>

          {/* Terms */}
          <div className="bg-gray-50 p-6 rounded-lg mb-8">
            <h2 className="text-2xl font-semibold mb-4">Terms & Conditions</h2>
            <ul className="space-y-3 text-gray-700">
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                Delivery to your front door.
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                One's order can be canceled if your have any issues
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                Payment Terms will decide on conversation.
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                Sometimes we might cancel the order due to other logistics issue or for any mango shipment damage.
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                We provide Best Off best mangoes, but you're all responsible to care.
              </li>
              <li className="flex items-start">
                <span className="w-2 h-2 bg-yellow-500 rounded-full mt-2 mr-3"></span>
                We will replace the mangoes if your not satisified with our delivery.
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="bg-yellow-500 text-white p-6 rounded-lg flex items-center justify-between">
            <div className="flex items-center">
              <Phone className="h-8 w-8 mr-3" />
              <div>
                <p className="font-semibold">Contact Us</p>
                <p className="text-xl">9550729943</p>
              </div>
            </div>
            <a
              href="tel:9550729943"
              className="bg-white text-yellow-500 px-6 py-2 rounded-lg font-semibold hover:bg-gray-100 transition-colors"
            >
              Call Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkOrder;